import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { decodeHtml } from "../../utils/decodeHtml";
function Accounts() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const navigate = useNavigate();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [showAddOrderModal, setShowAddOrderModal] = useState(false);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Accounts</h2>
          </div>
        </div>
        <div className="row justify-content-center" style={{ marginTop: "-20px" }}>
          <div style={{ cursor: "pointer" }} onClick={() => navigate("/account/outstanding")} className="col-xl-2 col-md-2" >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-magnifying-glass fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/account/outstanding"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Outstanding
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ cursor: "pointer" }} onClick={() => navigate("/account/notissued")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-people-arrows fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <a href="javascript:void(0);" className="text-secondary fw-semibold me-2 d-inline-block">
                        Not Issued
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
}
export default Accounts;
